export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The learning objective was clear to me.",
			},
			{
				id: 2,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 3,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 4,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 5,
				text: "I was already interested in the subject of the course before I signed up for it.",
			},
			{
				id: 6,
				text: "The topic of the course is relevant.",
			},
			{
				id: 7,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 8,
				text: "The topic of the course is relevant for my future professional goals.",
			},
			{
				id: 9,
				text: "The difficulty of the content was adequate.",
			},
			{
				id: 10,
				text: "The amount of the content was adequate.",
			},
			{
				id: 11,
				text: "The pace of the course was adequate.",
			},
			{
				id: 12,
				text: "The requirements of the course were adequate.",
			},
			{
				id: 13,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 14,
				text: "The course was too difficult for me.",
			},
			{
				id: 15,
				text: "This course demanded too little from me.",
			},
			{
				id: 16,
				text: "The quality of the online material was good.",
			},
			{
				id: 17,
				text: "Sufficient online material was provided to elaborate on the content.",
			},
			{
				id: 18,
				text: "The online material was accessible in a timely manner.",
			},
			{
				id: 19,
				text: "The online material contributed to the understanding of the content.",
			},
			{
				id: 20,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 21,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 22,
				text: "The online appointments were well organized.",
			},
			{
				id: 23,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 24,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 25,
				text: "The course is an example of good digital education.",
			},
			{
				id: 26,
				text: "The available materials were optimal to rehearse the course.",
			},
			{
				id: 27,
				text: "The tutorial was helpful to me.",
			},
			{
				id: 28,
				text: "The tutorial deepened my understanding of the contents.",
			},
			{
				id: 29,
				text: "I was encouraged by the tutorial to critically examine the topics covered.",
			},
			{
				id: 30,
				text: "The content of the tutorial was clarified through examples.",
			},
			{
				id: 31,
				text: "The importance of the topics covered was conveyed within the tutorial.",
			},
			{
				id: 32,
				text: "During the tutorial, theory and practical application were put into relation to each other.",
			},
			{
				id: 33,
				text: "Overall, this was a good course.",
			},
			{
				id: 34,
				text: "I learned a lot in this course.",
			},
			{
				id: 35,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 36,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 37,
				text: "Do you attend the corresponding face-to-face lecture?",
				label: [
					{
						id: 1,
						text: "Yes, regularly",
					},
					{
						id: 2,
						text: "Yes, sometimes",
					},
					{
						id: 3,
						text: "Very rarely",
					},
					{
						id: 4,
						text: "No, never",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 38,
				text: "For what purpose do you use the online material?",
			},
			{
				id: 39,
				text: "Further remarks regarding the course (praise/criticism/proposal)",
			},
		],
	},
	{
		type: "age",
		id: 4,
		items: [
			{
				id: 40,
				text: "Age: ",
			},
		],
	},
	{
		type: "dsp",
		id: 5,
		items: [
			{
				id: 41,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 42,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 43,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 44,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 45,
				text: "Overall I evaluate the lecturer's perfomance with the grade",
				values: ["A", "B", "C", "D", "E"],
			},
		],
	},
];
